import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NetaqInput from "../components/NetaqInput";
import ActionButton from "../components/ActionButton";
import { ToastContainer, toast } from "react-toastify";
import axios from "../axios/axios";
import axiosUmbraco from "../axios/axiosUmbraco";
import { useTranslate } from "../components/TranslationText";
import { useSelector } from "react-redux";
import { RemovePlusFromString } from "../helper/RemovePlusFromString";
import Loader from "../components/Loader";
import ArenaTable from "../components/ArenaTable";
import ComingSoon from "../components/ComingSoon";
import CronometerCounter from '../components/CronometerCounter';
import {
  getFirestore,
  collection,
  where,
  query,
  onSnapshot,
  orderBy,
  limit,
  serverTimestamp,
} from "firebase/firestore";
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from "react-zoom-pan-pinch";
import axiosInstance from "../axios/axios";
import { formatDate } from "../helper/formatDate";
import { bookingTablesRequest } from "../firebase/collections";
import { useLocation, useNavigate } from "react-router";
import Arena64Table from "../components/Arena64Table";
import Arena22Table from "../components/Arena22Table";
import Popup from "reactjs-popup";
import Alshira3Table from "../components/Alshira3Table";
import { GuidGenerator } from "../helper/GuidGenerator";
import Arena77Table from "../components/Arena77Table";
import Arena77ZonesTable from "../components/Arena77ZonesTable";
import { aedLogoStyle, eFormButtonsContainer, getDirhamImage, iconContainer, showIconsContainer, whiteCard } from "../common/cssclasses";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import Arena75Table from "../components/Arena75Table";



const Controls = ({ setActiveZone }) => {
  const { zoomIn, zoomOut, resetTransform, zoomToElement } = useControls();
  const { translate } = useTranslate();

  return (
    <div className="zoomTools">
      <button className="tooltip" onClick={() => zoomIn()}><i class="fa-solid fa-magnifying-glass-plus"></i>   <span class="tooltiptext"> {translate('web.zoomIn', 'Zoom In')}</span></button>
      <button className="redbtn tooltip" onClick={() => zoomOut()}><i class="fa-solid fa-magnifying-glass-minus"></i> <span class="tooltiptext">{translate('web.zoomOut', 'Zoom Out')}</span></button>
      <button className="blueBtn tooltip" onClick={() => { resetTransform(); setActiveZone(''); }}><i class="fa-solid fa-magnifying-glass"></i> <span class="tooltiptext">{translate('web.zoomReset', 'Zoom Reset')}</span></button>
      <button className="blueBtn tooltip" onClick={() => { setActiveZone(''); resetTransform(); }}><i class="fa-solid fa-undo"></i> <span class="tooltiptext">{translate('web.zoneReset', 'Zone Reset')}</span></button>
    </div>
  );
};
const UMBRACOURL = process.env.REACT_APP_UMBRACO;

export default function BookTable({ isAds = false }) {

  const letter = ['0', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
  // umbraco
  const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;
  const BaseURL = process.env.REACT_APP_BASE_URL;
  const ContactUsID = process.env.REACT_APP_CONTANCT_US_ID;
  const { translate } = useTranslate();
  const location = useLocation();
  const maxTablesToReserve = 1;
  const [showPopUp, setShowPopUp] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const [showForm, setShowForm] = useState(false);
  const anonymousUserId = localStorage.getItem('AnonymousUserId') ?? GuidGenerator();
  localStorage.setItem('AnonymousUserId', anonymousUserId);

  const zonzesActive = searchParams.has("zonesActive")
    ? searchParams.get("zonesActive") == 'true' ? 'true' : 'false'
    : 'false';
  const currentEventId = searchParams.has("eventid")
    ? searchParams.get("eventid")
    : null;

  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const [contactus, setContactus] = useState([]);
  const [loaded, setloaded] = useState(false);
  const [templateName, setTemplateName] = useState('');

  const [totalTables, setTotalTables] = useState([]);
  const [totalTablesBackEnd, setTotalTablesBackEnd] = useState([]);
  const navigate = useNavigate();

  const [activeZone, setActiveZone] = useState('');




  const id = ContactUsID;

  function getCurrentLanguageUmbraco() {
    const lang = localStorage.getItem("eahsLang") ?? "en";
    return lang === "en" ? "en-US" : "ar-AE";
  }

  const [openingEvents, setOpeningEvents] = useState([]);
  const [eventsLoaded, setEventsLoaded] = useState(false)
  // get Open TO book Template
  async function getOpeningEvents() {
    const lang = localStorage.getItem("eahsLang") ?? "en";
    // const response = await axiosInstance.get(`bookingtable/getbookingtablesevents?Langauge=${lang}&isAdvertisingPackage=${isAds}`);
    const response = await axiosInstance.get(`bookingtable/GetBookingTablesEventsById?id=${currentEventId}&isAdvertisingPackage=${isAds}`);
    // setOpeningEvents(response.data.result);
    setEventsLoaded(true);
    setEventsLoaded(true);


    const filteredEvent = response.data.result.filter((item) => item.id == currentEventId);
    setOpeningEvents(filteredEvent)
    return filteredEvent;

  }

  async function getTemplateTables(event, id) {
    let userProfileCahched = localStorage.getItem('eahsUserProfile');
    let userProfile = '';
    if (userProfileCahched !== "") {
      userProfile = JSON.parse(localStorage.getItem('eahsUserProfile')) ?? '';
    }
    const eventID = id;
    const eventType = 'Show';

    const response = await axiosInstance.get(`bookingtable/geteventtemplatetables?EventId=${eventID}&EentType=${eventType}`);
    setTemplateName(response.data.result.templateCode);
    setTotalTables(response.data.result.tablesList.map((item) => ({ tableLetter: item?.tableLetter ?? item.tableNo, ...item })).sort((a, b) => b.tableNo - a.tableNo));
    setTotalTablesBackEnd(response.data.result.tablesList.map((item) => ({ tableLetter: item?.tableLetter ?? item.tableNo, ...item })).sort((a, b) => b.tableNo - a.tableNo));
    const pastHoldingTables = response.data.result.tablesList;
    let filterdTables = []
    if (!!userProfile?.id) {
      filterdTables = await pastHoldingTables.filter((x) => (x.ownerId == userProfile.id && x.ownerId != "" && x.ownerId != null && x.ownerId != undefined && x.status === 4))
      setSelectedTables(filterdTables.map((x) => x.id));
    } else {

      filterdTables = await pastHoldingTables.filter((x) => (x.anonymousUserId == anonymousUserId && x.anonymousUserId != "" && x.anonymousUserId != null && x.anonymousUserId != undefined && x.status === 4))
      setSelectedTables(filterdTables.map((x) => x.id));
    }

    if (filterdTables.length > 0) {
      setNowDate(new Date(filterdTables[0].holdEndDate))
    }

    setIsLoading(false);
    const lastTotal = filterdTables.map((x) => x.price).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    setTotalAmount(lastTotal);
    // subscribeToRealTimeHoldedTables(filterdTables);
  }
  const getRealTimeHoldedTables = async () => {
    try {
      const q = query(
        bookingTablesRequest,
        where('EventId', '==', currentEventId),
        orderBy('DateTime', 'desc')
        , limit(1)
      );
      return q;
    } catch (error) {
      console.log('error')
    }
  };

  const [TimerIsFinished, setTimerIsFinished] = useState(false);
  let userProfileCahched = localStorage.getItem('eahsUserProfile');
  let userProfile = '';
  if (userProfileCahched !== "") {
    userProfile = JSON.parse(localStorage.getItem('eahsUserProfile')) ?? '';
  }
  const updateBackendWithFirestore = (backendArray, firestoreArray) => {
    const nowDate = new Date();

    // Calculate the date and time 20 minutes from now
    const twentyMinutesFromNow = new Date(nowDate.getTime() + 20 * 60 * 1000);

    // Filter the array to get only items where holdEndDate is within the next 20 minutes
    const firestoreTables = firestoreArray.filter(item => {
      const holdEndDate = new Date(item.holdEndDate);
      return holdEndDate >= nowDate && holdEndDate <= twentyMinutesFromNow;
    });
    const excludeIds = firestoreTables.map(item => item.id);

    const filterdBackendarray = backendArray.filter(item => !excludeIds.includes(item.id));

    if (firestoreArray.length > 0) {
      return [...firestoreArray];
    } else {
      return [...backendArray];
    }
  };

  const [fireBaseConnected, setFireBaseConnected] = useState(false);
  const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);  // Flag to track the initial load

  async function subscribeToRealTimeHoldedTables() {
    try {
      const q = await getRealTimeHoldedTables(); // Await the Promise to get the Query object

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const newData = [];
        querySnapshot.forEach((doc) => {
          newData.push(doc.data());
        });

        // console.log("newDataTables Are", newData);
        if (newData.length === 0) return;

        const latestTables = newData[0];
        // console.log("latest Tables Are", latestTables.TablesList);
        const isLoggedInUser = !!userProfile;

        const formattedData = latestTables.TablesList.map((table, index) => ({
          holdEndDate: table.HoldEndDate,
          id: table.Id,
          listOfTables: table.ListOfTables,
          ownerId: table.OwnerId,
          price: table.Price,
          status: table.Status,
          tableNo: table.TableNo,
          anonymousUserId: table.AnonymousUserId,
          tableLetter: table?.TableLetter ?? table.TableNo
        }));

        setFireBaseConnected(true);
        if (!initialLoadCompleted) {
          setInitialLoadCompleted(true);
          return;
        }

        // console.log('allTables From Back end are', totalTables);
        if (totalTables.length > 0) {
          const updatedTables = updateBackendWithFirestore(totalTables, formattedData);
          setTotalTables(updatedTables.map((item) => ({ tableLetter: item?.tableLetter ?? item.tableNo, ...item })).sort((a, b) => b.tableNo - a.tableNo));
        }
      });

      return unsubscribe;
    } catch (error) {
      console.log('Error in Firestore', error);
    }
  }



  useEffect(() => {
    async function getdata() {
      const umbraco = await axiosUmbraco.get(
        `/umbraco/delivery/api/v1/content/item?id=${id}`,
        {
          headers: {
            "accept-language": getCurrentLanguageUmbraco(),
          },
        }
      );
      const formattedData = umbraco.data?.map((item) => ({
        contactWhatsApp: item?.properties?.contactWhatsApp ?? "",
        contactTitle: item?.properties?.contactTitle ?? "",
        contactPhone: item?.properties?.contactPhone ?? "",
        contactMapUrl: item?.properties?.contactMapUrl ?? "",
        contactEmail: item?.properties?.contactEmail ?? "",
        contactDescription: item?.properties?.contactDescription ?? "",
        contactAddress: item?.properties?.contactAddress ?? "",
      }));
      setContactus(formattedData);
      if (umbraco.data.length > 0) {
        setloaded(true);
      }
    }
    // getdata();
    getOpeningEvents()
    if (openingEvents.length > 0) {

      getTemplateTables(openingEvents[0], currentEventId);
      subscribeToRealTimeHoldedTables();

    }


    const metaTag = document.createElement("meta");
    metaTag.name = "viewport";
    metaTag.content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    document.head.appendChild(metaTag);

    // Cleanup function to remove the meta tag when the component is unmounted
    return () => {
      document.head.removeChild(metaTag);
    };


  }, [currentLanguage, eventsLoaded, fireBaseConnected]);


  // end of umbraco
  const [paymentDetails, setPaymentDetails] = useState({
    tableEglishName: userProfile.fullName,
    tableArabicName: userProfile.fullNameAr,
    email: userProfile.email,
    contactNumber: userProfile.phone,
    collectorName: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTables, setSelectedTables] = useState([]);


  const handleChange = (event) => {
    setPaymentDetails({
      ...paymentDetails,
      [event.target.name]: event.target.value,
    });
  };

  const handelUrlToPayment = (isOnlinePayment = true, paymentURl) => {
    const returnUrl = `${BaseURL}/profile?activeTab=paymentHistory`;

    const encodeURI = encodeURIComponent(returnUrl);
    const homeurl = `${BaseURL}/`;
    const encodedHome = encodeURIComponent(homeurl);
    if (isOnlinePayment == true) {
      window.location.href = paymentURl;
    } else {
      window.location.href = paymentURl + '&isOnline=no';
    }
  };

  const handleSubmit = async (event, isOnlinePayment = true) => {
    event.preventDefault();
    const fields = ["tableEglishName", "tableArabicName", "contactNumber", "email", "collectorName"]; // Add more fields as needed
    const emptyFields = fields.filter((field) => !(paymentDetails[field]?.trim()));
    setIsLoading(true);
    if (emptyFields.length > 0) {
      toast.error(
        `${translate(
          "web.pleaseFillInTheAllfields",
          "Please fill in the All fields"
        )}: ${emptyFields.join(", ").toUpperCase()}`
      );
      setIsLoading(false);
      return;
    }
    if (packageList?.length > 0) {
      if (!selectedPackage?.value) {
        toast.error(
          `${translate(
            "web.selectYourPackage",
            "Selected Package"
          )}` + " " + `${translate(
            "web.isRequired",
            "Is Required"
          )}`
        );
        setIsLoading(false);
        return;
      }
      if (!!selectedPackage?.value) {
        if (selectedPackage?.isAllShows == false) {
          if (!selectedShow?.value) {
            toast.error(
              `${translate(
                "web.selectShow",
                "Selected Show"
              )}` + " " + `${translate(
                "web.isRequired",
                "Is Required"
              )}`
            );
            setIsLoading(false);
            return;
          }
        }
      }
    }

    try {
      const send = await axios.post("/bookingtable/createbookingtablesrequest", {
        ...paymentDetails, listOfTables: selectedTables, eventId: currentEventId, packageId: selectedPackage?.value, showId: selectedShow?.value, ...(!!anonymousUserId ? { anonymousUserId: anonymousUserId } : {})
      });
      if (send.data.responseCode === "200") {
        if (isOnlinePayment) {
          toast.success(
            translate("web.redirectToPaymentPage", "Redirect To Payment Page")
          );
        } else {
          toast.success(translate("web.reservationDone", "Reservation Done"))
        }
        setIsLoading(false);
        setPaymentDetails({
          tableEglishName: "",
          tableArabicName: "",
          email: '',
          contactNumber: '',
          collectorName: ''
        });
        const paymentURl = send.data?.result;
        handelUrlToPayment(isOnlinePayment, paymentURl)
      } else {
        toast.error("Payment Request does not Sent Succecfully Check API");
        setIsLoading(false);
      }
    } catch (error) {
      toast.error("Error in try Catch");
      setIsLoading(false);
    }
  };

  const dismissAll = () => toast.dismiss();
  const [totalAmount, setTotalAmount] = useState(0);
  const [nowDate, setNowDate] = useState(new Date());
  async function removeHold(tableID, istimeout = false) {

    let currentDate = new Date();
    // Add 10 minutes to the current time
    currentDate.setMinutes(currentDate.getMinutes() + 10);
    setNowDate(currentDate);
    if (!istimeout) {
      setTimerIsFinished(false);
    }
    const response = await axiosInstance.post('bookingtable/removetablehold', { id: tableID, ...(!!anonymousUserId ? { anonymousUserId: anonymousUserId } : {}) })

  }
  async function addToHold(selectedTables) {
    if (isAds && selectedTables.length > maxTablesToReserve) {
      return;
    }

    let currentDate = new Date();

    // Add 10 minutes to the current time
    currentDate.setMinutes(currentDate.getMinutes() + 10);
    setNowDate(currentDate);
    setTimerIsFinished(false);

    if (!!userProfile?.id) {
      const response = await axiosInstance.post('bookingtable/settableshold', { listOfTables: selectedTables.toString() })
    } else {
      const response = await axiosInstance.post('bookingtable/settableshold', { listOfTables: selectedTables.toString(), anonymousUserId: anonymousUserId })
    }

  }


  const toggleTableSelection = (tableID, tablePrice) => {
    // if (!userProfile) {
    //   navigate(`/login?redirectURL=${location.pathname}?eventid=${currentEventId}`);
    //   return;
    // }

    setSelectedTables((prevState) => {
      const isSelected = prevState.includes(tableID);

      // Only allow adding if maxTablesToReserve limit is not reached
      if (!isSelected && prevState.length >= maxTablesToReserve && isAds) {
        // Optional: Show a message or warning to the user
        console.warn(`You can only reserve a maximum of ${maxTablesToReserve} tables.`);
        // setShowPopUp(true)
        toast.error(translate('web.youCanOnlyReserveAMaximumOf', 'You can only reserve a maximum of') + " " + maxTablesToReserve + " " + translate('web.table', 'table') + " " + translate('web.perTime', 'Per Time'))
        return prevState;
      }

      const updatedTables = isSelected
        ? prevState.filter((num) => num !== tableID)  // Deselect table
        : [...prevState, tableID];  // Select table
      // Update total amount based on table selection
      setTotalAmount((prevAmount) =>
        isSelected ? prevAmount - tablePrice : prevAmount + tablePrice
      );
      if (isSelected) {

        removeHold(tableID);  // Remove hold if deselected

      } else {
        addToHold([...prevState, tableID]);  // Add hold if selected

      }
      // Update the table's status only if selection was successful (i.e., limit not reached)
      setTotalTables((prev) => {
        const currentTableIndex = prev.findIndex((table) => table.id === tableID);
        const leftSlice = prev.slice(0, currentTableIndex);
        const currentTable = prev[currentTableIndex];
        currentTable.status = currentTable.status === 1 ? 4 : 1;
        currentTable.ownerId = userProfile?.id;
        currentTable.anonymousUserId = anonymousUserId;
        const rightSlice = prev.slice(currentTableIndex + 1);
        return [...leftSlice, currentTable, ...rightSlice];
      });

      return updatedTables;
    });
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  useEffect(() => {
    if (TimerIsFinished) {
      selectedTables.forEach(table => {
        // removeHold(table, true);
        const tablePrice = totalTables.filter((alltable) => alltable.id == table);

        toggleTableSelection(table, tablePrice[0].price)
      })
    }
  }, [TimerIsFinished])

  const firstRowOptions = [
    {
      label: translate('web.TableReservation&DigitalAdvertising', 'Table Reservation & Digital Advertising (for 5 championships)'),
      text: translate('web.TableReservation&DigitalAdvertising', 'Table Reservation & Digital Advertising (for 5 championships)'),
      value: 1,
      price: 157500
    },
    {
      label: translate('web.TableReservation', 'Table Reservation (for 5 championships)'),
      text: translate('web.TableReservation', 'Table Reservation (for 5 championships)'),
      value: 2,
      price: 76500
    },
    {
      label: translate('web.TableReservationOneShow', 'Table Reservation (for 1 championship)'),
      text: translate('web.TableReservationOneShow', 'Table Reservation (for 1 championship)'),
      value: 3,
      price: 15750
    },
  ];
  const secondRowOptions = [
    {
      label: translate('web.TableReservation', 'Table Reservation (for 5 championships)'),
      text: translate('web.TableReservation', 'Table Reservation (for 5 championships)'),
      value: 1,
      price: 15750
    },
    {
      label: translate('web.TableReservationOneShow', 'Table Reservation (for 1 championship)'),
      text: translate('web.TableReservationOneShow', 'Table Reservation (for 1 championship)'),
      value: 2,
      price: 3150
    },
  ];





  const [selectedPackage, setSelectedpackage] = useState(null)
  const [selctedSecondRow, setSelectedSecondRow] = useState(null)
  const [selectedShow, setSelectedShow] = useState(null);





  useEffect(() => {
    setpackageList(reMapPackageList());
    setSelectedpackage(null);
    setShowOptions(reMapShowList());
  }, [selectedTables, showForm])

  function reMapPackageList(tableId = "") {
    let packageList = [];
    if (selectedTables.length > 0) {
      packageList =
        totalTablesBackEnd.find((item) => item?.id === selectedTables[0])?.packagesList?.map((x) => ({
          text: x?.packageName,
          label: x?.packageName,
          lable: x?.packageName,
          value: x?.packageId,
          ...x
        }))
    }
    return packageList;
  }
  function reMapShowList(tableId = "") {
    let showLists = [];
    if (selectedTables.length > 0) {
      showLists =
        totalTablesBackEnd.find((item) => item?.id === selectedTables[0])?.showsList?.map((x) => ({
          text: x?.showName,
          label: x?.showName,
          lable: x?.showName,
          value: x?.showId,
          ...x
        }))
    }
    return showLists;
  }
  const [packageList, setpackageList] = useState([]);
  const [showOptions, setShowOptions] = useState([])


  return (
    <>
      {
        eventsLoaded && (
          <>
            <ToastContainer
              position="top-right"
              onClick={dismissAll}
              theme="colored"
              autoClose={10000}
            />
            {showPopUp &&
              <Popup
                overlayStyle={{ zIndex: 5000 }}
                open={showPopUp}
                onClose={() => setShowPopUp(false)}
              >
                {(close) => (
                  <>
                    <div className="text-center text-danger" onClick={() => setShowPopUp(false)}>
                      {translate('web.youCanReserveJust', 'You Can Reserve Just') + " " + maxTablesToReserve + " " + translate('web.table', 'table')}
                    </div>
                    <br />
                    <ActionButton type={'normalbtn'} text={translate("web.close", "Close")} onClick={() => close()} />
                  </>
                )}
              </Popup>
            }
            <>
              <div className="row noMarginRow rtl ">
                {isAds &&
                  <>
                    <h3 className=" NewsPostTitle bold mb-main  rtl">
                      {translate('web.advertisingPackages', 'Advertising Packages')}
                    </h3>
                  </>
                }
                {!isAds &&
                  <h3 className=" NewsPostTitle bold  mb-main rtl">
                    {translate('web.tableReservationOf', 'Table reservation of')} {openingEvents[0].eventName} {new Date(openingEvents[0].startDate).getFullYear()}
                  </h3>
                }

                {!isAds &&
                  <div className="row rtl " style={{ width: 'unset' }} >
                    <div className=" showDetaisLabel  rtl  " style={{ width: 'unset' }}>
                      <i
                        className="fa fa-calendar C89C66"
                      ></i>
                      <span>
                        {translate("web.from", "From")} : {formatDate(openingEvents[0].startDate)}
                      </span>
                    </div>
                    <div className=" showDetaisLabel  rtl" style={{ width: 'unset' }} >
                      <i
                        className="fa fa-calendar C89C66"
                      ></i>
                      <span>
                        {translate("web.to", "To")} : {formatDate(openingEvents[0].endate)}
                      </span>
                    </div>
                  </div>}
                {!!(openingEvents[0]?.addressText) &&
                  (!!openingEvents[0]?.mapLocation[0] && !!openingEvents[0].addressText && !isAds
                    ?
                    <div className="justRotate px-0" style={{ width: 'unset' }}>
                      <Link to={openingEvents[0].mapLocation[0]} target="_blank" className="d-inline-block showDetaisLabel  justRotate rtl C89C66" style={{ width: 'unset' }}>
                        <i className="fa-solid fa-location-dot C89C66"></i>
                        <span style={{ textDecoration: 'underline' }}>
                          {openingEvents[0]?.addressText}
                        </span>
                      </Link>
                    </div>
                    :
                    (!!openingEvents[0].addressText && !isAds) &&
                    <div className="justRotate px-0" style={{ width: 'unset' }} >
                      <div className="d-inline-block showDetaisLabel justRotate  rtl C89C66" style={{ width: 'unset' }}>
                        <i
                          className="fa-solid fa-location-dot C89C66"
                        ></i>
                        <span>
                          {openingEvents[0]?.addressText}
                        </span>
                      </div>
                    </div>
                  )
                }
              </div>
              {isAds &&
                <div className="row rtl" style={{ flexWrap: 'wrap-reverse' }}>

                  <div className="col-lg-12 col-md-12 col-sm-12 mb-main">
                    {!!openingEvents[0].advertisingPackageTitle &&
                      <div className={whiteCard}>
                        <div className="col-lg-12 col-md-12 colsm-12 mx-auto currentFont" dangerouslySetInnerHTML={{ __html: openingEvents[0].advertisingPackageTitle }} />
                      </div>
                    }
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 mb-main">
                    <div className={whiteCard}>
                      <img style={{ width: '100%', }} className="border-15" alt="Book A Table Banner" src={`${BaseURL}/assets/img/Banner EAHS 2.png`} />
                    </div>
                  </div>
                </div>
              }
              <div className="row noMarginRow  ">
                <div className="col-lg-12 col-md-12 col-sm-12 " style={{ position: 'relative' }}>

                  <div
                    className="row noMarginRow "
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      // maxWidth: '80%',
                      margin: 'auto',
                      position: 'relative'
                    }}
                  >
                    <div className={whiteCard} style={{ direction: 'ltr' }}>
                      <TransformWrapper
                        // initialScale={windowWidth > 1367 ? 0.5 : windowWidth * 0.0005}
                        initialScale={0.43}
                        // initialPositionX={0}
                        // initialPositionY={0}
                        minScale={0.1}
                        smooth
                        // centerOnInit={windowWidth > 1367 ? (templateName == 'Alshira3' ? false : true) : true}
                        centerOnInit={true}
                        centerZoomedOut
                        pinch={{ disabled: true, }}
                        wheel={{ wheelDisabled: true, touchPadDisabled: true }}
                        className={'bg-light'}
                      >
                        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                          <>
                            <Controls setActiveZone={setActiveZone} />
                            <TransformComponent wrapperStyle={{ width: '100%', height: 400, paddingTop: zonzesActive == 'true' ? 50 : 25 }}  >
                              {templateName == 'IthadArena75' && zonzesActive == 'false' &&
                                <Arena75Table totalTables={totalTables} renderPrice={true} activeZone={activeZone} setActiveZone={setActiveZone} toggleTableSelection={toggleTableSelection} BaseURL={BaseURL} translate={translate} />
                              }
                              {templateName == 'IthadArena' && zonzesActive == 'false' &&
                                <Arena77Table totalTables={totalTables} activeZone={activeZone} setActiveZone={setActiveZone} toggleTableSelection={toggleTableSelection} BaseURL={BaseURL} translate={translate} />
                              }
                              {templateName == 'IthadArena' && zonzesActive == 'true' &&
                                <Arena77ZonesTable totalTables={totalTables} activeZone={activeZone} setActiveZone={setActiveZone} toggleTableSelection={toggleTableSelection} BaseURL={BaseURL} translate={translate} />
                              }
                              {templateName == 'Template64' &&
                                <Arena64Table totalTables={totalTables} toggleTableSelection={toggleTableSelection} BaseURL={BaseURL} translate={translate} />
                              }
                              {templateName == 'Template22' &&
                                <Arena22Table isAds={isAds} totalTables={totalTables} toggleTableSelection={toggleTableSelection} BaseURL={BaseURL} translate={translate} />
                              }
                              {templateName == 'Alshira3' &&
                                <Alshira3Table totalTables={totalTables} toggleTableSelection={toggleTableSelection} BaseURL={BaseURL} translate={translate} />
                              }
                            </TransformComponent>
                          </>
                        )}
                      </TransformWrapper>
                    </div>

                  </div>

                  <div className="BookingTableRow alignselfflexCenter TabelLegendContainer bg-white mt-4 border-15">
                    <div className="TableLegend">
                      <ArenaTable
                        tableNumber={'available'}
                        tablePrice={0}
                        state={'available'}
                      />
                      <h6> {translate('web.availableTable', 'Available Table')}</h6>
                    </div>
                    <div className="TableLegend">
                      <ArenaTable
                        tableNumber={'booked'}
                        tablePrice={0}
                        state={'booked'}
                      />
                      <h6> {translate('web.bookedTable', 'Booked Table')}</h6>
                    </div>
                    <div className="TableLegend">
                      <ArenaTable
                        tableNumber={'selected'}
                        tablePrice={0}
                        state={'selected'}
                      />
                      <h6> {translate('web.selectedTable', 'Selected Table')}</h6>
                    </div>
                    <div className="TableLegend">
                      <ArenaTable
                        tableNumber={'NA'}
                        tablePrice={0}
                        state={'NA'}
                      />
                      <h6> {translate('web.unavailableTable', 'Unavailable Table')}</h6>
                    </div>
                    <div className="TableLegend">
                      <ArenaTable
                        tableNumber={'holded'}
                        tablePrice={'0'}
                        state={'hold'}
                      />
                      <h6> {translate('web.holdedTable', 'Holded Table')}</h6>
                    </div>
                  </div>
                </div>
                {selectedTables.length > 0 && TimerIsFinished == false && !showForm &&
                  <div onClick={() => { setShowForm(true); }} style={{ position: 'fixed', bottom: 0, left: 0, zIndex: 50000 }}>
                    <div className="btn btn-danger w-100 d-flex justify-content-center align-items-center fw-bold"   > {translate('web.continue', 'Continue')} </div>
                  </div>
                }
                {selectedTables.length > 0 && TimerIsFinished == false &&
                  <div className={`bookingFormContainer ${showForm && 'showBookingForm'} d-flex pt-5`} style={{ position: 'fixed', zIndex: 5000 }}>
                    <form
                      className="col-lg-12 col-md-12 col-sm-12 border-15 p-4  bg-white mx-auto rtl"
                      style={{ position: "relative", maxWidth: 1100, overflowY: 'auto', maxHeight: '88vh', overflowX: 'hidden' }}
                    >
                      <div onClick={() => setShowForm(false)} className="btn btn-danger" style={{ position: 'absolute', top: 5, right: 5 }} ><i className=" fa fa-times fa-lg w-unset"></i></div>
                      {selectedTables.length > 0 && TimerIsFinished == false &&
                        <div className="mb-main">
                          <CronometerCounter isMinutes={true} className="redbtn" isBookingPage={true} endDate={nowDate} setTimerIsFinished={setTimerIsFinished} />
                        </div>
                      }
                      <div className={showIconsContainer}>
                        {selectedTables.map((table) => (
                          <>
                            <div className={iconContainer} >
                              <i className=" fa-solid fa-box red"></i> <span style={{ width: 125, display: 'inline-block' }}> {translate('web.tableno', 'TableNo')}   {totalTables.find((item) => (item.id == table)).tableLetter} </span>
                            </div>
                            <div className={iconContainer} >
                              <i className=" red fa-solid fa-couch"></i> {isAds ? "7" : '6'}
                            </div>
                            {!isAds &&
                              <div className={iconContainer} >
                                <img src={getDirhamImage(currentLanguage)} alt="AED" style={aedLogoStyle} />
                                {totalTables.find((item) => (item.id == table)).price.toLocaleString('en-US')} {translate('web.aed', 'AED')}
                              </div>
                            }
                          </>
                        ))}
                        {(selectedPackage != null) &&
                          <div className={iconContainer + ' w-unset'} >

                            <img src={getDirhamImage(currentLanguage)} alt="AED" style={aedLogoStyle} />
                            <span>{translate('web.totalAmount', 'Total Amount')}</span>  {isAds ?
                              <>
                                {selectedTables.map((table) => (
                                  <>
                                    {Math.abs(selectedPackage?.price).toLocaleString('en-US')} {translate('web.aed', 'AED')}
                                  </>
                                ))}
                              </> :
                              <>
                                {Math.abs(totalAmount).toLocaleString('en-US')} {translate('web.aed')}
                              </>
                            }
                          </div>
                        }
                      </div>
                      <div className="row">

                        {packageList?.length > 0 && selectedTables.map((table) => (
                          <>
                            {selectedTables.length > 0 &&
                              <>
                                <div className="col-xl-6 col-lg-6 col-md-12 mb-form-group">
                                  <NetaqInput
                                    required={true}
                                    key={'selectedTables' + selectedTables[0]}
                                    value={selectedPackage}
                                    onChange={(item) => setSelectedpackage(item)}
                                    name={"bookType"}
                                    label={translate(
                                      "web.selectYourPackage",
                                      "SelectYourPackage"
                                    )}
                                    placeholder={translate(
                                      "web.selectYourPackage",
                                      "SelectYourPackage"
                                    )}
                                    hideSelectedOptions={false}
                                    type={"select"}
                                    listSelect={packageList}
                                  />
                                </div>
                                {selectedPackage?.isAllShows == false
                                  &&
                                  <div className="col-xl-6 col-lg-6 col-md-12 mb-form-group">
                                    <NetaqInput
                                      required={true}
                                      value={showOptions.find((item) => selectedShow?.value == item?.value)}
                                      onChange={(item) => setSelectedShow(item)}
                                      name={"bookType"}
                                      label={translate(
                                        "web.selectShow",
                                        "selectShow"
                                      )}
                                      placeholder={translate(
                                        "web.selectShow",
                                        "selectShow"
                                      )}
                                      hideSelectedOptions={false}
                                      type={"select"}
                                      listSelect={showOptions}
                                    />
                                  </div>
                                }
                              </>

                            }
                          </>
                        ))}

                        <div className="col-xl-6 col-lg-6 col-md-12 mb-form-group">
                          <NetaqInput
                            required={true}
                            value={paymentDetails.tableEglishName}
                            onChange={handleChange}
                            name={"tableEglishName"}
                            label={translate(
                              "web.EnglishName(NameToBePrintedOnTable)",
                              "English Name (Name to be printed on table)"
                            )}
                            placeholder={translate("web.fullName", "Full Name")}
                            type={"text"}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 mb-form-group">
                          <NetaqInput
                            required={true}
                            value={paymentDetails.tableArabicName}
                            onChange={handleChange}
                            name={"tableArabicName"}
                            label={translate(
                              "web.ArabicName(NameToBePrintedOnTable)",
                              "Arabic Name (Name to be printed on table)"
                            )}
                            placeholder={translate(
                              "web.ArabicName(NameToBePrintedOnTable)",
                              "Arabic Name (Name to be printed on table)"
                            )}
                            type={"text"}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 mb-form-group">
                          <NetaqInput
                            required={true}
                            value={paymentDetails.contactNumber}
                            onChange={handleChange}
                            name={"contactNumber"}
                            label={translate("web.contactNumber", "Contact Number")}
                            placeholder={translate("web.phone", "Phone")}
                            type={"text"}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 mb-form-group">
                          <NetaqInput
                            required={true}
                            value={paymentDetails.email}
                            onChange={handleChange}
                            name={"email"}
                            label={translate("web.email", "Email")}
                            placeholder={translate("web.email", "Email")}
                            type={"email"}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 mb-form-group">
                          <NetaqInput
                            required={true}
                            value={paymentDetails.collectorName}
                            onChange={handleChange}
                            name={"collectorName"}
                            label={translate("web.collectorName", "Collector Name")}
                            placeholder={translate("web.collectorName", "Full Name")}
                            type={"text"}
                          />
                        </div>
                      </div>

                      <div className={eFormButtonsContainer}>
                        {isLoading ? (
                          <Loader />
                        ) : (
                          <>
                            <SubmitServiceBtn
                              text={translate("web.proceedToPayment", "Proceed To Payment")}
                              onClick={(e) => { handleSubmit(e, true) }}
                            />
                            {userProfile?.participateWithoutPaymentBooking == true &&
                              <ApproveAndPayLaterBtn
                                text={translate("web.payLater", "Pay Later")}
                                onClick={(e) => { handleSubmit(e, false) }}
                              />
                            }
                          </>
                        )}
                      </div>
                    </form>
                  </div>
                }

              </div>

            </>
          </>
        )
      }
    </>
  );
}